import { RootState } from '../reducers';

export namespace DrawerSelectors {
	export const getCurrentDrawer = (state: RootState) => state.app.drawer;
}
